import { reports } from "@/mocks/observeData";
import { SectionHeading, SectionShell } from "./common";

export default function ReportSection() {
  return (
    <SectionShell id="report" className="bg-background-100/70 py-14 md:py-20">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <SectionHeading
          eyebrow="IN-DEPTH"
          title="深度专题与避坑指南"
          desc="把散落的线索整理成能直接照着做的清单与方法论，帮你少走弯路、少踩坑。"
        />
        <span className="shrink-0 self-start rounded-md bg-secondary-100 px-3 py-1.5 text-sm font-medium text-secondary-900 lg:self-auto">
          持续选题 · 不定期更新
        </span>
      </div>

      <div className="mt-9 grid grid-cols-1 gap-6 md:grid-cols-2">
        {reports.map((r) => (
          <article
            key={r.id}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200 md:flex-row"
          >
            <div className="relative h-48 w-full shrink-0 overflow-hidden md:h-auto md:w-[42%]">
              <img
                src={r.image}
                alt={`${r.title}专题封面`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-background-50/90 px-2.5 py-1 text-xs font-bold text-primary-700">
                <i className="ri-fire-line" />
                {r.tag}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                <span className="font-bold text-accent-700">{r.category}</span>
                <span className="h-1 w-1 rounded-full bg-secondary-300" />
                <span className="inline-flex items-center gap-1">
                  <i className="ri-time-line" />约 {r.readMin} 分钟阅读
                </span>
              </div>
              <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                {r.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{r.excerpt}</p>
              <a
                href="#guide"
                className="mt-4 inline-flex items-center gap-1.5 self-start whitespace-nowrap text-sm font-bold text-primary-600 hover:text-primary-800 cursor-pointer"
              >
                结合核实指南阅读
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </article>
        ))}
      </div>
    </SectionShell>
  );
}